import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpandAll = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.6635 11.3069C18.1098 10.8606 18.1098 10.1358 17.6635 9.68956L10.8086 2.83471C10.3624 2.38843 9.63761 2.38843 9.19133 2.83471C8.74505 3.28099 8.74505 4.00575 9.19133 4.45202L15.2393 10.5L9.1949 16.548C8.74862 16.9943 8.74862 17.719 9.1949 18.1653C9.64118 18.6116 10.3659 18.6116 10.8122 18.1653L17.6671 11.3104L17.6635 11.3069ZM3.95379 18.1617L10.8086 11.3069C11.2549 10.8606 11.2549 10.1358 10.8086 9.68956L3.95379 2.83471C3.50752 2.38843 2.78276 2.38843 2.33648 2.83471C1.8902 3.28099 1.8902 4.00575 2.33648 4.45202L8.38445 10.5L2.34005 16.548C1.89377 16.9943 1.89377 17.719 2.34005 18.1653C2.78633 18.6116 3.51109 18.6116 3.95737 18.1653L3.95379 18.1617Z",
		fill: "#0D2976"
	})
});
export default SvgExpandAll;
